import React, { Component } from "react";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import { projectsLocalization, number, neNumberToEn } from "localization";
import { media } from "components/styled";

class Pagination extends Component {
  state = {};

    componentDidMount() {
        this.updatePaginationItems(this.props.selectedLanguage);
    }

    componentDidUpdate(prevProps) {

        if (prevProps.selectedLanguage !== this.props.selectedLanguage) {
            this.updatePaginationItems(this.props.selectedLanguage);
        }
    }

    updatePaginationItems(type) {
        const paginationItems = document.querySelectorAll('.pagination li');
        paginationItems.forEach((item,index) => {
            if (index !== 0 && index !== paginationItems.length - 1) {
                const link = item.querySelector('a');
                link.innerHTML = type === "np" ? number(link.innerHTML) : neNumberToEn(link.innerHTML);
            }
        });
    }
  render() {
    const { pagination, handleChangePagination, selectedLanguage } = this.props;
    const { previous, next } = projectsLocalization[selectedLanguage];
    return (
      pagination.total_pages && (
        <PaginationMain>
          <ReactPaginate
            previousLabel={previous}
            nextLabel={next}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={pagination.total_pages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handleChangePagination}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={pagination.current_page - 1}
          />
        </PaginationMain>
      )
    );
  }
}

const PaginationMain = styled.div`
  .pagination {
    background-color: ${props => props.theme.primary.darkGrey};
    border-radius: 4px;
    display: flex;
    justify-content: center;
    padding: 5px 0;
    margin-top: 30px;
    li {
      ${media.tabletWide` margin: 0 4px;`};
      a {
        border-radius: 50%;
        color: var(--color-theme);
        cursor: pointer;
        display: block;
        font-size: ${props => props.theme.fontSize.md}px;
        line-height: 22px;
        text-align: center;
        margin: 0 1px;
        min-width: 22px;
        opacity: 0.6;
        transition: all 0.3s ease-in;
        &:hover {
          opacity: 1;
        }
        ${media.tabletSmall`
        min-width: 24px;
        line-height: 24px;
        margin: 0 3px;
        `};
      }
      &.active a {
        background-color: ${props => props.theme.primary.pissYellow};
        color: ${props => props.theme.primary.darkGrey};
        opacity: 1;
      }
      &.previous {
        margin-right: 4px;
      }
      &.next {
        margin-left: 4px;
      }
      &.break-me {
        > a {
          pointer-events: none;
        }
      }
    }
  }
`;

export default connect(state => ({
  selectedLanguage: state.localizationReducers.selectedLanguage
}))(Pagination);



// WEBPACK FOOTER //
// ./src/components/layouts/pagination/pagination.js